import { Field, useField, FieldConfig, FieldInputProps, GenericFieldHTMLAttributes } from 'formik';

import { Input, FormFieldContainer, StyledErrorMessage } from './styles';

type ElementOrComponent = keyof JSX.IntrinsicElements | React.ComponentType<any>;

const FormField = <AsComponent extends ElementOrComponent, V>({
  name,
  label,
  id,
  children,
  style,
  required,
  as,
  ...props
}: Omit<
  React.ComponentPropsWithRef<AsComponent extends ElementOrComponent ? AsComponent : never>,
  keyof FieldInputProps<V>
> &
  GenericFieldHTMLAttributes & {
    as?: AsComponent;
    label?: string;
  } & FieldConfig<V>) => {
  const [field, meta, helpers] = useField(name);

  return (
    <FormFieldContainer style={style}>
      {Boolean(label) && (
        <label htmlFor={name}>
          {label}
          {required && '*'}
        </label>
      )}
      <Field
        {...props}
        as={as ?? Input}
        id={id ?? name}
        name={name}
        aria-describedby={`${name}-error`}
        errored={meta.error && meta.touched}
      >
        {children}
      </Field>
      {/* @ts-expect-error TS(2769): No overload matches this call. */}
      <StyledErrorMessage name={name} id={`${name}-error`} component="div" role="alert" />
    </FormFieldContainer>
  );
};

export default FormField;
export * from './fields.component';
